import { Box, Typography, Grid } from '@mui/material'
import React, { Fragment } from 'react'
import { Loading } from '../../../UI'
import { CollapseButton } from '../../../UI/CollapseButton/CollapseButton'
import { usePutAway } from '../../Context/usePutAway'
import { useStyles } from './styles'

export const HistoryPutAway = () => {
  const classes = useStyles()
  const { state } = usePutAway()
  const { workOrderSkuHistory, item, loadingHistory } = state

  return (
    <Fragment>
      <Box
        component='div'
        display='flex'
        flexDirection='column'
        flexWrap='nowrap'
        alignItems='center'
        padding='0 20px 0 20px'
      >
        <div
          className='descripcion'
          style={{ textIndent: '10%', width: '100%' }}
        >
          <Typography variant='h6' className={classes.details}>
            <b>ASN: </b>
            {item?.asnNumber}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>LPN: </b>
            {item?.workingLpn}
          </Typography>
          <Typography variant='h6' className={classes.details}>
            <b>OT: </b>
            {item?.workOrderId}
          </Typography>
        </div>
      </Box>

      {loadingHistory && workOrderSkuHistory.length === 0 && (
        <div style={{ marginTop: '100px', marginRight: '20px' }}>
          <Loading />
        </div>
      )}

      {!loadingHistory && workOrderSkuHistory.length > 0 && (
        <Box
          component='div'
          display='flex'
          flexDirection='column'
          flexWrap='nowrap'
          alignItems='center'
          padding='10px 17px 0 10px'
          className={classes.container}
        >
          {workOrderSkuHistory.map((skuHistoryLocated) => (
            <CollapseButton
              header={skuHistoryLocated.skuName}
              handleClick={undefined}
              showButton={false}
            >
              <Grid container xs={12} spacing={1}>
                <Grid item xs={12}>
                  <Typography variant='body2' component='p'>
                    <b>Ubicación: </b>
                    {skuHistoryLocated.positionName}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' component='p'>
                    <b>SKU: </b>
                    {skuHistoryLocated.sku}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' component='p'>
                    <b>Cantidad: </b> {skuHistoryLocated.locatedQty}
                  </Typography>
                </Grid>
              </Grid>
            </CollapseButton>
          ))}
        </Box>
      )}

      {!loadingHistory && workOrderSkuHistory.length === 0 && (
        <Box
          component='div'
          display='flex'
          flexDirection='column'
          flexWrap='nowrap'
          alignItems='center'
          padding='10px 10px 0px 10px'
        >
          <Typography
            variant='h5'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '300px',
              padding: '20px 30px',
              wordBreak: 'break-word',
              wordWrap: 'break-word'
            }}
          >
            No hay registros de SKU(s) ubicados
          </Typography>
        </Box>
      )}
    </Fragment>
  )
}
